<template>
    <div class="page white_bg">

        <div style="height: 46px;"><!-- set height if pageHeader is fixed position -->
            <header class="pageHeader white_bg" style="line-height: 30px;">
                <div class="borderLayout paddingH16 paddingV8">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 30px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
<!--                            <router-link class="primaryTextColor bold" to="">链接</router-link>-->
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">

            <div class="paddingH16 marginT24">
                <bannerModule ref="bannerModule" version="4"
                  :type="adTypeEnum.CHOICENESS_DATUM_PAGE.code"/>
            </div>

            <div class="datumListContainer marginT4" style="padding: 0 12px 0 12px;">

                <div class="bold" style="padding: 20px 6px; color: hsla(0, 0%, 17%, 1)">
                    资料列表
                </div>

                <div class="datumList">
                    <div class="datumItem" v-for="dataItem in dataList" :key="dataItem.id" @click="view(dataItem)">
                        <div class="flexLayout">
                            <div style="width: 65px; margin-right: 6px;">
                                <div class="imageArea roundBorder8"
                                     style="width: 65px; height: 86px;">
                                    <!--                                        <img class="fullSpace roundBorder8" :src="dataItem.coverImg" alt=""/>-->
                                    <img class="fullSpace" src="datum/file_icon_word_65x85.png" v-if="dataItem.fileType === 'WORD'"/>
                                    <img class="fullSpace" src="datum/file_icon_pdf_65x85.png" v-if="dataItem.fileType === 'PDF'"/>
                                    <img class="fullSpace" src="datum/file_icon_ppt_65x85.png" v-if="dataItem.fileType === 'PPT'"/>
                                    <img class="fullSpace" src="datum/file_icon_package_65x85.png" v-if="dataItem.fileType === 'IMAGE_TEXT'"/>
                                    <img class="fullSpace" src="datum/file_icon_package_65x85.png" v-if="dataItem.fileType === 'TEACHING_PLAN'"/>
                                    <img class="fullSpace" src="datum/file_icon_audio_65x85.png" v-if="dataItem.fileType === 'MUSIC'"/>
                                    <img class="fullSpace" src="datum/file_icon_video_65x85.png" v-if="dataItem.fileType === 'VIDEO'"/>
                                    <img class="fullSpace" src="datum/file_icon_package_65x85.png" v-if="dataItem.fileType === 'ZIP'"/>
                                </div>
                            </div>
                            <div class="flexItem">
                                <div class="titleArea maxHeightTwoLine font14r"
                                     style="padding-top: 9px; line-height: 1.3em; height: 2.6em; text-overflow: ellipsis">
                                    {{dataItem.title}}
                                </div>
                                <div class="clearfix" style="margin-top: 9px;">
                                    <i class="fl icon-category icon datumVipLabelIcon marginR16" v-show="dataItem.price && dataItem.isVip"></i>

<!--                                    <span class="fr font18r colorFA585C bold" v-show="!dataItem.price">免费</span>-->
<!--                                    <div class="inlineBlock fr colorFA585C bold" v-show="dataItem.price">-->
<!--                                        <span class="font12r">￥</span>-->
<!--                                        <span class="font18r">{{dataItem.price}}</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>
                        <div class="flexLayout marginT8 grey60 font12r bold">

                            <div class="flexItem" style="padding-left: 6px">
                                格式：
                                <span v-if="dataItem.fileType === 'WORD'">Word</span>
                                <span v-else-if="dataItem.fileType === 'PDF'">Pdf</span>
                                <span v-else-if="dataItem.fileType === 'PPT'">PPT</span>
                                <span v-else-if="dataItem.fileType === 'IMAGE_TEXT'">图文</span>
                                <span v-else-if="dataItem.fileType === 'TEACHING_PLAN'">教案</span>
                                <span v-else-if="dataItem.fileType === 'MUSIC'">音乐</span>
                                <span v-else-if="dataItem.fileType === 'VIDEO'">视频</span>
                                <span v-else-if="dataItem.fileType === 'ZIP'">压缩包</span>
                                <span v-else>{{dataItem.fileType}}</span>
                            </div>
<!--                            <div class="flexItem alignCenter">-->
<!--                                {{dataItem.pv}}浏览量-->
<!--                            </div>-->
<!--                            <div class="flexItem alignRight">-->
<!--                                {{dataItem.downloadCount}}下载量-->
<!--                            </div>-->
                        </div>
                        <div v-if="isDebug && dataItem.isPay" class="">
                            (已购买)
                        </div>
                    </div><!-- end .datumItem -->

                </div><!-- end .datumList -->

                <div class="alignCenter paddingV8" v-show="status === 'loading'">
                    <i class="icon spinner-loader"></i>
                </div>

                <div class="paddingV16 alignCenter font14r colorCCC"
                     v-show="status==='ready' && dataList.length && pagination.current == pagination.totalPage"
                     :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                    没有更多资料了
                </div>

                <div class="paddingV16 alignCenter font14r colorCCC"
                     v-show="status==='ready' && dataList.length < 1">
                    <img src="datum/no_any_datum_206x143.png" width="206" height="auto">
                    <br/>
<!--                    <button class="button block centered yellowHollowButton marginT24" style="width: auto">去筛选其他资料</button>-->
                </div>

                <div class="" style="margin-top: 12px; margin-bottom: 32px;"
                     v-show="status==='ready' && pagination.current < pagination.totalPage"
                     @click="loadNextPage()">
                    <img class="block loadMoreButton" src="button/loadMoreButton.png" width="100%" height="auto"/>
                </div>

                <div style="height: 30px;"></div>

            </div>
        </div>

    </div><!-- end .page -->
</template>

<script>

import shixunPagePart   from '@/components/shixunApp/shixunPagePart';
import bannerModule     from "@/components/ad/oneImageAdModule";

// config
import appConfig from '@/appConfig';

// data
import adTypeEnum   from '@/components/ad/adTypeEnum';
import externalApp  from '@/data/externalApp';
import agilityTitleLocationTypeEnum from '@/data/agilityTitleLocationTypeEnum';

// api
import agilityTitleApi  from '@/api/agilityTitle';

// utils
import consoleHelper    from '@/util/consoleHelper';
import appHelper        from '@/util/appHelper';

const config = {
    apiConfig : {
        list : {
            url : 'portal/datum/getHandpick',
            params : {},
            dataPath : 'data.data.records',
            totalPagePath : 'data.data.pages',
        }
    }
};

export default {
    name: "datumChoiceness",
    extends : shixunPagePart,
    components : { bannerModule },
    data () {
        return {
            title : '资料',

            apiConfig : config.apiConfig,
            enableDataList : true,      // 开启 dataList 功能
            autoLoadDataList : appConfig.mode !== 'demo',
            scrollToLoadNextPage : false,    // 无限拖动加载
            pageSize : 15,
            externalApp : externalApp,

            adTypeEnum : adTypeEnum,

            isDebug : consoleHelper.getDebugStatus()
        }
    },
    methods : {
        loadAgilityTitle() {
            agilityTitleApi.getByLocationType(
                agilityTitleLocationTypeEnum.CHOICENESS_DATUM_MODULE.code,
                (result) => {
                    this.title = result.data;
                }
            )
        },
        view : function (item) {
            // let url = externalApp.oldShixun.baseUrl + 'html/downloadDetail.html?id=' + item.id;
            // appHelper.redirect(url);
            appHelper.goToPage('datumDetail', {
                id : item.id
            });
        },

    },
    mounted() {
        this.loadAgilityTitle();
    }
}
</script>

<style lang="scss" scoped>

.datum_price{
    margin-top: 12px;
    font-size: 16px;

    font-weight: 500;
    color: #FC3439;
}

.icon-category{
    width: 53px;
    height: 16px;
}

.datumListContainer {
    .header {

        .title {
            position: relative;
            padding-left: 8px;
            line-height: 22px;
        }
    }

    .datumItem {
        padding: 16px 0 12px;
    }
}
.searchButtonArea.fixed {
    position: fixed;
    z-index: 5;
    right: 20px;
    bottom: 100px;
}
.yellowHollowButton {
    height: 30px;
    padding: 0 14px;
    background: #FFFFFF;
    border: 1px solid #FFA724;
    box-sizing: border-box;
    border-radius: 16px;

    font-size: 14px;
    line-height: 30px;
    color: #FFA724;
}
</style>
